import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'fl-toast-alert-container',
  template: `
    <fl-bit class="ToastAlertContainer" id="toast-alert-container">
      <ng-content></ng-content>
    </fl-bit>
  `,
  styleUrls: ['./toast-alert-container.component.scss'],
})
export class ToastAlertContainerComponent {
  constructor(public elementRef: ElementRef) {}
}
